<template>
<div>
    <ul class="result_item">
        <li 
          @click="selectItem(item)"
          v-for="(item,index) in dataList" 
          :key="index" 
          class="list_view_item"
        >
            <div class="item">
              <span class="item_title" v-html="item.bt"></span>
              <span v-if="item.lx.indexOf('图文稿件') > -1" class="item_content" v-html="item.zhaiyao"></span>
            </div>
            <div class="item_imgs">
              <div v-for="(url, index) in item.urls" :key="index"> 
                <img v-if="item.lx.indexOf('图片') > -1 && index<5" class="item_img" :src="url" />
              </div>
            </div>
            <div class="item_video_pic" v-if="item.lx.indexOf('视频') > -1 && item.thumbnail">
              <div class="top__front"></div>
              <img class="item_video" :src="item.thumbnail[0] ? item.thumbnail[0] : '../static/img/default.jpg'" />
              <img class="item_play" src="../static/img/play.png" />
            </div>
            <img v-if="item.lx.indexOf('音频') > -1" class="item_music" src="../static/img/mp3.png" />
            <div class="item_detail">
                <img src="../static/img/fbsj.png" /><span >发布时间：{{item.fbsj}} </span>
                <img src="../static/img/fgmt.png"/><span v-if="item.fgmt">发稿来源：{{item.fgmt.mc}} </span><span v-else>发稿来源：{{item.fgly}} </span>
                <img src="../static/img/lylx.png" /><span >来源类型：{{item.lyqd}} </span>
            </div>
        </li>
    </ul>
    <span class="span_read_more" v-show="readMoreShow" @click="readMore">加载更多……</span>
</div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: ""
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  created() {
    //console.log(this.dataList)
  },
  computed:{
    readMoreShow(){
      return (this.dataList && this.total > 10) && (this.dataList.length < this.total)
    }
  },
  methods: {
    selectItem(item) {
      if(item.lx.indexOf('视频') > -1){
        this.$emit("select", item.id, item.lx, item.urls);
      }
      else{
        this.$emit("select", item.id, item.lx, item.urls);
      }
    },
    readMore(){
      this.$emit('readMoreList')
    }
  },
  mounted(){
  },
  watch: {
    dataList(newVal) {
      this.dataList = newVal;
      //console.log(this.dataList,this.total)
    }
  }
};
</script>

<style>
.result_item li {
  padding: 16px 10px 0px 10px;
  border-bottom: 1px dotted #ddd;
  list-style-type: none;
  cursor: pointer;
  background-color: #fff
}
.result_item li:hover {
  background-color: #eee;
}
.result_item li .item_imgs{
  display: flex;
}
.result_item li .item_img {
  margin-top: 14px;
  padding-right: 14px;
  width: 128px;
  height: 93px;
}

.result_item li .item_music {
  margin-top: 14px;
}

.item .item_title {
  /*! autoprefixer: off */
  height: 18px;
  font-size: 18px;
  font-family: 思源黑体;
  font-weight: 550;
  color: rgba(51, 51, 51, 1);
  line-height: 18px;
  letter-spacing: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* autoprefixer: on */
}

.item_content {
  font-size: 16px;
  font-family: 思源黑体;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin-top: 14px;
  line-height: 23px;
  letter-spacing: 2px;
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
   /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp:2;
  /* autoprefixer: on */
}

.item_detail {
  display: flex;
  margin-top: 13px;
  padding-bottom: 16px;
  align-items: center;
}

.item_detail img {
  width: 12px;
  height: 12px;
}

.item_detail span {
  width: 260px;
  padding-left: 6px;
  margin-right: 40px;
  font-size: 14px;
  font-family: 思源黑体;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
}
.item{
  display: flex;
  flex-direction: column;
}
.span_read_more{
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.span_read_more:hover{
   background-color: #eee;
}
.list_view_item:last-child{
  border-bottom: none;
}
.item_video_pic{
  position: relative;
  margin-top: 14px;
  width: 238px;
  height: 153px;
  background: #000;
}
.item_video_pic .item_video{
  display: block;
  width: 238px;
  height: 153px;
  opacity:0.6; 
  filter: alpha(opacity=60);
}
.item_video_pic .item_play{
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 17%;
  margin-left: 50px;
  margin-top: -28px;
}
</style>



// WEBPACK FOOTER //
// src/components/listView.vue